import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang, useSeo } from "../i18n/LangContext";
import { Reveal } from "../components/site/Reveal";
import { PageHeader, FinalCta } from "../components/site/Sections";

const accents = ["#FF682F", "#005F60", "#FFCC00"];

const Pillar = ({ p, i, w }) => (
  <section id={p.id} className="scroll-mt-24 border-t border-[#121518]" data-testid={`pillar-${p.id}`}>
    <div className="mx-auto grid max-w-[1400px] gap-10 px-6 py-16 sm:px-10 lg:grid-cols-12 lg:py-28">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <div className="flex items-center gap-4">
              <span className="h-4 w-4" style={{ background: accents[i] }} aria-hidden="true" />
              <span className="f-serif text-lg italic text-[#4A525A]">{p.num}</span>
            </div>
            <h2 className="f-serif mt-6 text-[clamp(2.8rem,6vw,5.5rem)] leading-[0.95] tracking-[-0.025em]">{p.name}</h2>
            <p className="mt-4 text-[11px] uppercase tracking-[0.28em] text-[#4A525A]">{p.via}</p>
          </Reveal>
        </div>
      </div>
      <div className="lg:col-span-6 lg:col-start-7">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.28em] text-[#005F60]">{w.problemLabel}</p>
          <p className="f-serif mt-4 text-2xl leading-snug lg:text-[1.9rem]">{p.problem}</p>
        </Reveal>
        <Reveal delay={0.1} className="mt-14">
          <p className="text-[11px] uppercase tracking-[0.28em] text-[#005F60]">{w.deliverLabel}</p>
          <ul className="mt-4">
            {p.deliver.map((d, k) => (
              <li key={d} className="group flex items-baseline gap-6 border-b border-[#E2DDD5] py-5 transition-colors duration-300 hover:border-[#121518]">
                <span className="w-6 shrink-0 text-xs text-[#4A525A]">{String(k + 1).padStart(2, "0")}</span>
                <span className="text-base transition-transform duration-500 group-hover:translate-x-1.5 lg:text-lg">{d}</span>
              </li>
            ))}
          </ul>
          <Link to={`/contacto?interesse=${p.interest}`} className="btn-dark mt-10 inline-flex" data-testid={`pillar-talk-${p.id}`}>
            {w.talk} <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);

export default function WhatWeDo() {
  const { t } = useLang();
  useSeo("what");
  const w = t.whatPage;
  return (
    <>
      <PageHeader eyebrow={w.eyebrow} lines={w.lines} intro={w.intro} testId="what-header" />
      {t.pillars.map((p, i) => <Pillar key={p.id} p={p} i={i} w={w} />)}
      <FinalCta />
    </>
  );
}
